import React, {useMemo} from "react";
import {useSelector} from "react-redux";
import BigNumber from "bignumber.js";

import Box from "../../Interface/Box";
import Separator from "../../Interface/Separator/Separator";
import BalanceRow from "../../Interface/BalanceRow";
import Button from "../../Interface/Button/Button";
import UnlockButton from "../../Interface/UnlockButton";
import { useWeb3React } from "@web3-react/core";
import {useEthereum} from "../../../EthereumContext";
import {convertBalance} from "../../../utils";
import {toast} from "react-toastify";
import './style.scss';
import useResize from "../../../hooks/useResize";

function StakedInfo() {
    const { account } = useWeb3React();
    const { staking } = useEthereum();
    const { userBalance, userUnlockedBalance, userReward } = useSelector(store => store.staking);

    const [pending, setPending] = React.useState(false);
    const { windowWidth } = useResize();
    const mobileView = useMemo(() => windowWidth <= 600, [windowWidth]);

    const onHarvest = async () => {
        setPending(true);
        try {
            const tx = await staking.getReward({gasLimit: 2000000});
            await tx.wait();
            toast.info("Harvesting is completed");
        } catch {
            toast.error("Harvesting failed");
        } finally {
            setPending(false);
        }
    };

    return (
        <Box className="info" direction="column" align="flex-start">
            ROOBEE At Stake
            <Separator />
            <BalanceRow
                name="Locked ROOBEE"
                value={convertBalance((new BigNumber(userBalance)).minus(new BigNumber(userUnlockedBalance)))}
            />
            <BalanceRow name="Unlocked ROOBEE" value={convertBalance(userUnlockedBalance)} />
            <BalanceRow name="Total ROOBEE" value={convertBalance(userBalance)} />
            <Separator light short />
            <div className="info-wrapper">
                {account ? (
                    <Button
                        style={{marginLeft: 40}}
                        onClick={onHarvest}
                        disabled={pending || userReward === "0"}
                        blinking={pending}
                    >
                        Harvest
                    </Button>
                ) : (
                    <UnlockButton className="info-unlock" style={{marginLeft: 40}} />
                )}
                <div style={{marginTop: -20, flexGrow: 1}}>
                    <BalanceRow name="Governance Reward ROOBEE" value={convertBalance(userReward)} />
                </div>
            </div>
        </Box>
    );
}

export default StakedInfo;
